exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3Kga{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "_3Kga",
	"root": "_3Kga"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./containers/blogue/Blogue.css
// module id = 236
// module chunks = 0